'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp2; // import Button from 'material-ui/Button';
// import ClickAwayListener from 'material-ui/utils/ClickAwayListener';
// import Collapse from 'material-ui/transitions/Collapse';
// import Portal from 'material-ui/Portal';
// import { MenuItem, MenuList } from 'material-ui/Menu';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactPopper = require('react-popper');

var _Grow = require('material-ui/transitions/Grow');

var _Grow2 = _interopRequireDefault(_Grow);

var _Paper = require('material-ui/Paper');

var _Paper2 = _interopRequireDefault(_Paper);

var _styles = require('material-ui/styles');

var _Notifications = require('material-ui-icons/Notifications');

var _Notifications2 = _interopRequireDefault(_Notifications);

var _NotificationsActive = require('material-ui-icons/NotificationsActive');

var _NotificationsActive2 = _interopRequireDefault(_NotificationsActive);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _ListItem = require('material-ui/List/ListItem');

var _ListItem2 = _interopRequireDefault(_ListItem);

var _CircularProgress = require('material-ui/Progress/CircularProgress');

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _List = require('material-ui/List');

var _List2 = _interopRequireDefault(_List);

var _Delete = require('material-ui-icons/Delete');

var _Delete2 = _interopRequireDefault(_Delete);

var _Message = require('material-ui-icons/Message');

var _Message2 = _interopRequireDefault(_Message);

var _component = require('@prisma-cms/component');

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    root: {
      display: 'flex'
    },
    paper: {
      marginRight: theme.spacing.unit * 2
    },
    popperClose: {
      pointerEvents: 'none'
    },
    menuItem: {
      '&:focus': {
        backgroundColor: theme.palette.primary.main,
        '& $primary, & $icon': {
          color: theme.palette.common.white
        }
      }
    },
    primary: {},
    icon: {
      // color: "white",
      "&.active": {
        color: theme.palette.secondary.main
      }
    },
    listItemText: {
      paddingLeft: 0,
      paddingRight: 22
    }
  };
};

var NoticesList = (_temp2 = _class = function (_PrismaCmsComponent) {
  _inherits(NoticesList, _PrismaCmsComponent);

  function NoticesList() {
    var _temp, _this, _ret;

    _classCallCheck(this, NoticesList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PrismaCmsComponent.call.apply(_PrismaCmsComponent, [this].concat(args))), _this), _this.state = _extends({}, _PrismaCmsComponent.prototype.state, {
      open: false
    }), _this.handleToggle = function () {
      // console.log("handleToggle");
      _this.setState({
        open: !_this.state.open
      });
    }, _this.handleClose = function (event) {
      // console.log("handleClose");
      if (_this.target1.contains(event.target)) {
        return;
      }

      _this.setState({
        open: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  NoticesList.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var objectsConnection = this.props.data.objectsConnection;
    var open = this.state.open;
    var objects = objectsConnection && objectsConnection.edges.map(function (_ref) {
      var node = _ref.node;
      return node;
    }) || [];

    if (open && !objects.length) {
      this.setState({
        open: false
      });
    }

    _PrismaCmsComponent.prototype.componentDidUpdate && _PrismaCmsComponent.prototype.componentDidUpdate.call(this);
  };

  NoticesList.prototype.renderItems = function renderItems(objects) {
    var _this2 = this;

    var _context = this.context,
        ChatRoomLink = _context.ChatRoomLink,
        UserLink = _context.UserLink;
    var _props = this.props,
        classes = _props.classes,
        deleteNotice = _props.deleteNotice,
        refetch = _props.data.refetch;
    var inRequest = this.state.inRequest;
    return objects.map(function (n) {
      var noticeId = n.id,
          type = n.type;
      var item = void 0; // console.log("item", n);

      switch (type) {
        case "ChatMessage":
          {
            var ChatMessage = n.ChatMessage;

            var _ref2 = ChatMessage || {},
                contentText = _ref2.contentText,
                Room = _ref2.Room;

            var secondary = contentText && contentText.substr(0, 25) || undefined;
            item = _react2.default.createElement(_ListItem2.default, {
              key: noticeId,
              onClick: _this2.handleClose // dense

            }, _react2.default.createElement(_List.ListItemIcon, null, _react2.default.createElement(_Message2.default, null)), _react2.default.createElement(_List.ListItemText, {
              primary: _react2.default.createElement(ChatRoomLink, {
                object: Room
              }),
              secondary: secondary,
              className: classes.listItemText
            }), _react2.default.createElement(_List.ListItemSecondaryAction, null, inRequest && inRequest === noticeId ? _react2.default.createElement(_CircularProgress2.default, null) : _react2.default.createElement(_IconButton2.default, {
              'aria-label': 'Delete',
              onClick: function () {
                var _ref3 = _asyncToGenerator(
                /*#__PURE__*/
                _regenerator2.default.mark(function _callee(event) {
                  return _regenerator2.default.wrap(function _callee$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          event.preventDefault();
                          event.stopPropagation();

                          _this2.setState({
                            inRequest: noticeId
                          });

                          _context2.next = 5;
                          return deleteNotice({
                            variables: {
                              where: {
                                id: noticeId
                              }
                            }
                          }).then(refetch).catch(console.error);

                        case 5:
                          _this2.setState({
                            inRequest: null
                          });

                        case 6:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee, _this2);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }()
            }, _react2.default.createElement(_Delete2.default, null))));
          }
          break;

        case "ChatRoomInvitation":
          {
            var ChatRoomInvitation = n.ChatRoomInvitation,
                CreatedBy = n.CreatedBy;

            var _ref4 = ChatRoomInvitation || {},
                _contentText = _ref4.contentText,
                _Room = _ref4.ChatRoom;

            var _secondary = _react2.default.createElement(ChatRoomLink, {
              object: _Room
            }, "\u0412\u0430\u0441 \u043F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u043B\u0438 \u0432 \u0447\u0430\u0442-\u043A\u043E\u043C\u043D\u0430\u0442\u0443") || undefined;

            item = _react2.default.createElement(_ListItem2.default, {
              key: noticeId,
              onClick: _this2.handleClose // dense

            }, _react2.default.createElement(_List.ListItemIcon, null, _react2.default.createElement(UserLink, {
              user: CreatedBy,
              size: 'small',
              showName: false
            })), _react2.default.createElement(_List.ListItemText, {
              primary: _react2.default.createElement(ChatRoomLink, {
                object: _Room
              }),
              secondary: _secondary,
              className: classes.listItemText
            }), _react2.default.createElement(_List.ListItemSecondaryAction, null, inRequest && inRequest === noticeId ? _react2.default.createElement(_CircularProgress2.default, null) : _react2.default.createElement(_IconButton2.default, {
              'aria-label': 'Delete',
              onClick: function () {
                var _ref5 = _asyncToGenerator(
                /*#__PURE__*/
                _regenerator2.default.mark(function _callee2(event) {
                  return _regenerator2.default.wrap(function _callee2$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          event.preventDefault();
                          event.stopPropagation();

                          _this2.setState({
                            inRequest: noticeId
                          });

                          _context3.next = 5;
                          return deleteNotice({
                            variables: {
                              where: {
                                id: noticeId
                              }
                            }
                          }).then(refetch).catch(console.error);

                        case 5:
                          _this2.setState({
                            inRequest: null
                          });

                        case 6:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _callee2, _this2);
                }));

                return function (_x2) {
                  return _ref5.apply(this, arguments);
                };
              }()
            }, _react2.default.createElement(_Delete2.default, null))));
          }
          break;
      }

      return item;
    });
  };

  NoticesList.prototype.render = function render() {
    var _this3 = this,
        _classNames;

    var classes = this.props.classes;
    var open = this.state.open;
    var items = [];
    var objectsConnection = this.props.data.objectsConnection;
    var objects = objectsConnection && objectsConnection.edges.map(function (_ref6) {
      var node = _ref6.node;
      return node;
    }) || [];
    items = this.renderItems(objects);
    var Icon = _Notifications2.default;

    if (items.length) {
      Icon = _NotificationsActive2.default;
    }

    return _react2.default.createElement('div', {
      className: classes.root
    }, _react2.default.createElement(_reactPopper.Manager, null, _react2.default.createElement(_reactPopper.Target, null, _react2.default.createElement('div', {
      ref: function ref(node) {
        _this3.target1 = node;
      }
    }, _react2.default.createElement(_IconButton2.default, {
      'aria-owns': open ? 'menu-list-grow' : null,
      'aria-haspopup': 'true',
      onClick: function onClick(event) {
        event.preventDefault();
        event.stopPropagation();

        _this3.handleToggle();
      },
      className: [classes.icon, items.length && !open ? "active" : ""].join(" ")
    }, _react2.default.createElement(Icon, null)))), _react2.default.createElement(_reactPopper.Popper, {
      placement: 'bottom-start',
      eventsEnabled: open,
      className: (0, _classnames2.default)((_classNames = {}, _classNames[classes.popperClose] = !open, _classNames))
    }, _react2.default.createElement(_Grow2.default, {
      'in': open,
      id: 'menu-list-grow',
      style: {
        transformOrigin: '0 0 0'
      }
    }, _react2.default.createElement(_Paper2.default, null, _react2.default.createElement(_List2.default // role="menu"
    // dense
    , null, items))))));
  };

  return NoticesList;
}(_component2.default), _class.propTypes = _extends({}, _component2.default.propTypes, {
  classes: _propTypes2.default.object.isRequired,
  deleteNotice: _propTypes2.default.func.isRequired
}), _temp2);
exports.default = (0, _styles.withStyles)(styles)(function (props) {
  return _react2.default.createElement(NoticesList, props);
});
module.exports = exports['default'];